// @ts-check

/**
 * @typedef {Object} PrepareUserProfileUpdate_User_Type
 * @property {string} userId "384"
 * @property {string} contactId "1870"
 * @property {string} vFileId "37164"
 * @property {boolean} isEnabled true
 * @property {string} firstName "Mitchell"
 * @property {string} lastName "Sung"
 * @property {string} username "mitchell"
 * @property {string} phoneWork "123-456-7890"
 * @property {string} phoneWorkDialCode "1"
 * @property {string} phoneWorkCountryCode "ca"
 * @property {string} phoneWorkExt "1233"
 * @property {string} phoneMobile "403-805-4488"
 * @property {string} phoneMobileDialCode "1"
 * @property {string} phoneMobileCountryCode "ca"
 * @property {string} phoneMobileExt "1234"
 * @property {string} phoneOther "403-805-4321"
 * @property {string} phoneOtherDialCode "1"
 * @property {string} phoneOtherCountryCode "ca"
 * @property {string} phoneOtherExt ""
 * @property {string} emailWork "mitchell@streamdata.com"
 * @property {string} emailPersonal "mitchell@streamdata.com"
 * @property {string} emailOther "mitchell@streamdata.com"
 * @property {Object[]} userLanguages
 * @property {string} userLanguages.id "1"
 * @property {string} userLanguages.code "en"
 * @property {string} userLanguages.name "English"
 * @property {Object[]} userContactTypes
 * @property {string} userContactTypes.Id "28"
 * @property {string} userContactTypes.Title "Client"
 * @property {Object[]} userRoleGroups
 * @property {string} userRoleGroups.id "11"
 * @property {string} userRoleGroups.name "SDS_Admin"
 * @property {string} userRoleGroups.appId "0"
 * @property {Object[]} userCompanies
 * @property {string} userCompanies.RowNumber "45"
 * @property {string} userCompanies.Id "100"
 * @property {string} userCompanies.Name "LNN Protection"
 * @property {*} userAccessible
 * @property {string} userAccessible.RowNumber "45"
 * @property {string} userAccessible.Id  "100"
 * @property {string} userAccessible.Name "LNN Protection"
 * @property {Object[]} userAddresses
 * @property {string} userAddresses.address_id "487"
 * @property {string} userAddresses.type "4"
 * @property {string} userAddresses.street "135 Millview Square SW Millrise,"
 * @property {string} userAddresses.city "Calgary"
 * @property {string} userAddresses.province "AB"
 * @property {string} userAddresses.country "CA"
 * @property {string} userAddresses.postalCode "T2C 2R9"
 * @property {string} userAddresses.placeId "ChIJDalw8jp0cVMRj19rbMx9OvA"
 * @property {string} userAddresses.lat "50.978811500"
 * @property {string} userAddresses.lng "-113.968473400"
 * @property {string} userAddresses.unit "123"
 * @property {string} notes ""
 * @property {string} image "blob:http://localhost:8000/c841d336-7435-4d95-b4ad-8b9813c94542"
 * @property {string} password ""
 * @property {string} confirmPassword ""
 * @property {*} file
 */

/**
 * @typedef {Object} PrepareUserProfileUpdate_Return_Type
 * @property {string} Id
 * @property {string} ContactId
 * @property {number} VFileId
 * @property {boolean} IsEnabled
 * @property {string} FirstName
 * @property {string} LastName
 * @property {string} UserName
 * @property {string} WorkPhone
 * @property {string} WorkPhoneDialCode
 * @property {string} WorkPhoneCountryCode
 * @property {string} WorkPhoneExtension
 * @property {string} CellPhone
 * @property {string} CellPhoneDialCode
 * @property {string} CellPhoneCountryCode
 * @property {string} CellPhoneExtension
 * @property {string} HomePhone
 * @property {string} HomePhoneDialCode
 * @property {string} HomePhoneCountryCode
 * @property {string} HomePhoneExtension
 * @property {string} WorkEmail
 * @property {string} PersonalEmail
 * @property {string} OtherEmail
 * @property {string[]} Languages ["1"]
 * @property {string[]} ContactTypes ["5"]
 * @property {string[]} UserRoles ["201"]
 * @property {string[]} Customers ["366"]
 * @property {string} MasterCustomerId ""
 * @property {Object[]} Addresses
 * @property {string} Addresses.address_id "487"
 * @property {string} Addresses.type "4"
 * @property {string} Addresses.street "135 Millview Square SW Millrise,"
 * @property {string} Addresses.city "Calgary"
 * @property {string} Addresses.province "AB"
 * @property {string} Addresses.country "CA"
 * @property {string} Addresses.postalCode "T2C 2R9"
 * @property {string} Addresses.placeId "ChIJDalw8jp0cVMRj19rbMx9OvA"
 * @property {string} Addresses.lat "50.978811500"
 * @property {string} Addresses.lng "-113.968473400"
 * @property {string} Addresses.unit "-113.968473400"
 * @property {string} Note
 * @property {string} UserPassword
 * @property {string} ConfirmPassword
 */

/**
 * @function prepareUserProfileUpdate
 * @param {object} user
 * @param {string} fileId
 * @returns {object}
 */
function prepareUserProfileUpdate(user, fileId) {
	const preparedUser = {
		Id: user.userId,
		ContactId: user.contactId,
		VFileId: Number(fileId),
		IsEnabled: user.isEnabled,
		FirstName: user.firstName,
		LastName: user.lastName,
		UserName: user.username,
		WorkPhone: user.phoneWork,
		WorkPhoneDialCode: user.phoneWorkDialCode,
		WorkPhoneCountryCode: user.phoneWorkCountryCode,
		WorkPhoneExtension: user.phoneWorkExt,
		CellPhone: user.phoneMobile,
		CellPhoneDialCode: user.phoneMobileDialCode,
		CellPhoneCountryCode: user.phoneMobileCountryCode,
		CellPhoneExtension: user.phoneMobileExt,
		HomePhone: user.phoneOther,
		HomePhoneDialCode: user.phoneOtherDialCode,
		HomePhoneCountryCode: user.phoneOtherCountryCode,
		HomePhoneExtension: user.phoneOtherExt,
		WorkEmail: user.emailWork,
		PersonalEmail: user.emailPersonal,
		OtherEmail: user.emailOther,
		Languages: user.userLanguages.map((language) => language.id),
		ContactTypes: user.userContactTypes.map((contactType) => contactType.Id),
		UserRoles: user.userRoleGroups.map((group) => group.id),
		Customers: user.userCompanies.map((company) => company.Id),
		MasterCustomerId: user.userAccessible.Id,
		Addresses: user.userAddresses,
		Note: user.notes,
		UserPassword: user.password,
		ConfirmPassword: user.confirmPassword,
	};

	return preparedUser;
}

export default prepareUserProfileUpdate;
